import { render, staticRenderFns } from "./OrderRecordByProducts.vue?vue&type=template&id=6bf37161&scoped=true&"
import script from "./OrderRecordByProducts.vue?vue&type=script&lang=js&"
export * from "./OrderRecordByProducts.vue?vue&type=script&lang=js&"
import style0 from "./OrderRecordByProducts.vue?vue&type=style&index=0&id=6bf37161&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf37161",
  null
  
)

export default component.exports